'use client';

import React from 'react';
import { Center, Stack, Loader, Text, Card } from '@mantine/core';
import useSafeTranslation from '@/hooks/useSafeTranslation';

export type LoadingScreenProps = {
  labelKey?: string;
  defaultLabel?: string;
  loaderType?: 'bars' | 'oval' | 'dots';
};

export default function LoadingScreen({
  labelKey = 'app.initializing',
  defaultLabel = 'Inicializando aplicación…',
  loaderType = 'bars',
}: LoadingScreenProps) {
  const { tSafe } = useSafeTranslation();

  return (
    <Center h="100vh">
      <Card padding="xl" radius="xl" shadow="lg" withBorder>
        <Stack align="center" gap="md">
          <Loader type={loaderType} size="lg" />
          <Text size="sm" c="dimmed">
            {tSafe(labelKey, { defaultValue: defaultLabel })}
          </Text>
        </Stack>
      </Card>
    </Center>
  );
}
